(function ($, w) {

    "use strict";

    w.Confused = w.Confused || {};

    /**
    * Confused.LabelProvider returns labels from the lookup service
    * 
    * @constructor
    * @param {object} labels to provide
    **/
    w.Confused.LabelProvider = function (lookupService) {

        this.lookupService = lookupService;
    };

    /*
    * Gets a label. e.g.
    * labelProvider.getLabel(name)
    *
    * @param {string} key. The name of the label. Return and empty string if no match exists.
    **/
    w.Confused.LabelProvider.prototype.getLabels = function (paths) {

        var prop, i;
        var keys = [];
        var values = [];
        var promises = [];
        var labels = {};

        //  Get label keys and values
        for (prop in paths) {

            if (paths.hasOwnProperty(prop)) {

                keys.push(prop);
                values.push(paths[prop]);
                promises.push(this.lookupService.getLabel(paths[prop]));
            }
        }

        //  get label lookups

        var def = $.Deferred();

        $.when.apply($, promises)
            .then(function () {

                for (i = 0; i < arguments.length; i++) {

                    var result = JSON.parse(arguments[i][0]);

                    labels[keys[i]] = result;
                }

                def.resolve(labels);
            });

        return def;
    };

}(window.jQuery, window));

